import { render } from "./Ticker.vue?vue&type=template&id=6f8cd906"
import script from "./Ticker.vue?vue&type=script&lang=js"
export * from "./Ticker.vue?vue&type=script&lang=js"

import "./Ticker.vue?vue&type=style&index=0&id=6f8cd906&lang=css"
script.render = render

export default script